import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetAccountLegacyId as GetAccountLegacyIdQuery,
    GetAccountLegacyIdVariables,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_LEGACY_ID from '../queries/get-account-legacy-id.graphql';

export function useGetAccountLegacyId(accountId: string): {
    legacyId: string | undefined;
    shouldShowLegacyId: boolean;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch, networkStatus} = useQuery<
        GetAccountLegacyIdQuery,
        GetAccountLegacyIdVariables
    >(GET_ACCOUNT_LEGACY_ID, {
        variables: {accountId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    return {
        legacyId: data?.account?.legacyId ?? undefined,
        shouldShowLegacyId: data?.account?.shouldShowLegacyId ?? false,
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
